import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>404 — Page non trouvée</title>
        <meta property="og:title" content="404 — Page non trouvée" />
        <meta name="twitter:title" content="404 — Page non trouvée" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className={styles.header}>
        <h1 className={styles.title}>404</h1>
        <p className={styles.subtitle}>Page non trouvée</p>
      </section>

      <section className={styles.content}>
        <div className={styles.container}>
          <p className={styles.text}>
            Oops ! La page que vous cherchez n'existe pas ou a été déplacée.
          </p>
          <Link to="/" className={styles.homeButton}>
            Retour à l'accueil
          </Link>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
